import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.739 1.332c-.53 0-1.04.21-1.414.585l-5.14 5.141a2.275 2.275 0 0 0 0 3.215L5.913 14a2.275 2.275 0 0 0 3.215 0l5.14-5.14c.375-.375.586-.884.586-1.414V3.999a2.667 2.667 0 0 0-2.667-2.667zm3.448 1.334a1.33 1.33 0 0 1 1.333 1.333v3.448c0 .176-.07.346-.195.47l-5.14 5.141a.94.94 0 0 1-1.329 0L3.128 9.33a.94.94 0 0 1 0-1.33l5.14-5.14a.67.67 0 0 1 .47-.194zm-1 .999a1.334 1.334 0 1 0 .001 2.667 1.334 1.334 0 0 0 0-2.667"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })